import React from 'react'
import {message} from 'antd'
import DB from '../../DAL/DB'
import validateQuestions from './validateQuestions'

const rr = new DB.Rubrics()
// Add a reference to the projects collection
const projectsDB = new DB.Projects()

export default async function saveRubrics(formId, rubrics, sections, actions, enableAutoRubric) {
  const invalidQuestions = validateQuestions(rubrics, sections)

  if (!invalidQuestions) {
    const hideMessage = message.loading(`Saving...`)

    try {
      //Assemble a list of all rubrics already in the database for this form
      let results = await rr.makeQuery(null, { filters: [['formId', '==', formId]] }).get()

      let existingRubricsForForm = results.docs.map((rubric) => rubric.id)

      let providedRubrics = Object.keys(rubrics)

      //If any rubrics were found in the DB, but not provided to this function,
      // delete them.
      let deletePromises = []

      existingRubricsForForm.forEach((rubricId) => {
        if (!providedRubrics.includes(rubricId)) {
          deletePromises.push(rr.delete(rubricId))
        }
      })

      await Promise.all(deletePromises)

      //Save all of the rubrics provided
      await Promise.all(Object.values(rubrics).map((rubric) => rr.update(rubric.id, null, rubric)))

      // Update rubric in all non-completed projects for this rubric
      await Promise.all(Object.values(rubrics).map(async (rubric) => {
        // Query all projects where rubric.id == rubric.id
        const query = projectsDB.makeQuery(null, {
          filters: [
            ['rubric.id', '==', rubric.id]
          ]
        })
        const results = await query.get()
        if (results && results.docs && results.docs.length > 0) {
          // Filter out completed projects 
          const nonCompletedProjects = results.docs.filter(
            (projectDoc) => projectDoc.data().status !== 'Completed'
          )
          await Promise.all(nonCompletedProjects.map(async (projectDoc) => {
            // Update the rubric field in the project with the latest rubric details
            await projectsDB.update(projectDoc.id, null, {
              ...projectDoc.data(),
              rubric: rubric
            })
          }))
        }
      }))

    } catch (e) {
      console.log(e)
      throw e
    } finally {
      hideMessage()
      message.success(`Rubrics saved`)
    }
    return true
  } else {
    console.info('invalidQuestions:', invalidQuestions)

    const error = <div>
      {Object.values(invalidQuestions).map(({ error }) => <div>{error}</div>)}
    </div>
  
    message.error(error, 25)
  }
}
